// extracted by mini-css-extract-plugin
module.exports = {"sectionName":"styles-module--sectionName--OJMWT","line":"styles-module--line--2yLRz","name":"styles-module--name--VBJzL"};